export default ({request}) => ({
  ecomAmzMoqListApi(data = {}) {
    return request({
      url: '/ecom/amz/moq/list',
      method: 'post',
      data,
    })
  },
  ecomAmzMoqDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/moq/detail',
      method: 'post',
      data,
    })
  },
  ecomAmzMoqSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/moq/save',
      method: 'post',
      data,
    })
  },
  ecomAmzMoqDelApi(data = {}) {
    return request({
      url: '/ecom/amz/moq/del',
      method: 'post',
      data,
    })
  },
  ecomAmzMoqMaterialListApi(data = {}) {
    return request({
      url: '/ecom/amz/moq/material/list',
      method: 'post',
      data,
    })
  },
  ecomAmzMoqMaterialUpdateSkuMoqApi(data = {}) {
    return request({
      url: '/ecom/amz/moq/material/updateSkuMoq',
      method: 'post',
      data,
    })
  },
  ecomAmzMoqMaterialDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/moq/material/detail',
      method: 'post',
      data,
    })
  },
  ecomAmzMoqMaterialSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/moq/material/save',
      method: 'post',
      data,
    })
  },
  ecomAmzMoqMaterialDelApi(data = {}) {
    return request({
      url: '/ecom/amz/moq/material/del',
      method: 'post',
      data,
    })
  },
  masterFabricListApi(data = {}) {
    return request({
      url: '/master/fabric/list',
      method: 'post',
      data,
    })
  },
  masterFabricAttributesSelectApi(data = {}) {
    return request({
      url: '/master/fabric/attributes/attributesSelect',
      method: 'post',
      data,
    })
  },
  ecomAmzSkuListByMoqApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/listByMoq',
      method: 'post',
      data,
    })
  },
  ecomAmzSkuListByChooseApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/listByChoose',
      method: 'post',
      data,
    })
  },
  ecomAmzSkuMoqMaterialListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/moq/material/list',
      method: 'post',
      data,
    })
  },
  ecomAmzSkuMoqMaterialAddSkuApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/moq/material/addSku',
      method: 'post',
      data,
    })
  },
  ecomAmzSkuMoqMaterialUpdateApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/moq/material/update',
      method: 'post',
      data,
    })
  },
  ecomAmzSkuMoqMaterialDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/moq/material/del',
      method: 'post',
      data,
    })
  },
})
